"use client";

import { createContext, PropsWithChildren } from "react";

export const LocaleContext = createContext<undefined | string>(undefined);

export function LocaleContextProvider(
  props: PropsWithChildren<{
    locale?: string;
  }>,
) {
  let locale;
  if (props.locale) {
    locale = props.locale.split("-")[0];
  }

  return (
    <LocaleContext.Provider value={locale}>
      {props.children}
    </LocaleContext.Provider>
  );
}
